import { ReactNode, useEffect } from 'react';
import { DataTestId } from 'core/common/constants';
import { useServices } from 'core/common/hooks';
import { usePaymentActiveProvidersFeature } from 'core/payments/hooks';
import { ModalHeaderStyled, ModalStyled, ScrollAreaStyled } from './styled';

type PaymentDialogProps = {
  isOpen?: boolean;
  // Hides the dialog without "closing" it: no close/open analytics, form stays mounted (bottom-sheet errors)
  isHidden?: boolean;
  onClose?: () => void;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
};

export const PaymentDialog = ({
  isOpen = false,
  isHidden = false,
  onClose,
  header,
  footer,
  children,
}: PaymentDialogProps) => {
  const { analyticsService } = useServices();
  const { defaultMethod } = usePaymentActiveProvidersFeature();

  useEffect(() => {
    if (!isOpen) return;

    analyticsService.trackPaymentFormState({ state: 'open', payment_method: defaultMethod });
  }, [isOpen, analyticsService, defaultMethod]);

  const handleClose = () => {
    analyticsService.trackPaymentFormState({ state: 'close' });

    if (onClose) {
      onClose();
    }
  };

  return (
    <ModalStyled open={isOpen && !isHidden} keepMounted onClose={handleClose}>
      <>
        <ModalHeaderStyled
          onClose={handleClose}
          data-testid={DataTestId.PAYMENT_MODAL_CLOSE_BUTTON}
        />
        <ScrollAreaStyled>
          {header}
          {children}
          {footer}
        </ScrollAreaStyled>
      </>
    </ModalStyled>
  );
};
